import React from "react";
import { t } from "copy/t";

/**
 * A short line of text beside a control that explains why it is off, or what
 * went wrong. Tie it to the control with `aria-describedby={id}`. Pass
 * `role="alert"` for a failure that should be announced at once.
 */
export const InlineNote = ({ id, role, tone = "info", onRetry, children }) => (
  <p
    id={id}
    role={role}
    className={`text-[13px] m-0 mt-3 ${
      tone === "error" ? "text-[#C0392B]" : "text-[#5B6B73]"
    }`}
  >
    {children}
    {onRetry && (
      <>
        {" "}
        <button
          type="button"
          className="underline bg-transparent border-0 p-0 cursor-pointer text-inherit"
          onClick={onRetry}
        >
          Try again
        </button>
      </>
    )}
  </p>
);

// The text of a rejected save: the server's own message when it sent one,
// otherwise the generic save-failed copy. Rails answers with `error`,
// `message`, or a per-field `errors` map depending on the failure.
export const saveErrorMessage = (errors) => {
  const fallback = t("toast.channel.saveFailed");
  if (!errors || typeof errors !== "object") return fallback;
  if (typeof errors.error === "string" && errors.error) return errors.error;
  if (typeof errors.message === "string" && errors.message) return errors.message;
  if (errors.errors && typeof errors.errors === "object") {
    const parts = Object.entries(errors.errors).map(([field, msgs]) =>
      `${field.replace(/_/g, " ")} ${[].concat(msgs).join(", ")}`
    );
    if (parts.length) return parts.join("; ");
  }
  return fallback;
};
